export class Facility {
  constructor (params = {}) {
    this.id = params.id ? params.id : null
    this.sequence = params.sequence ? params.sequence : null
    this.name = params.name ? params.name : null
    this.timezone = params.timezone ? params.timezone : null
    this.editable = params.editable ? params.editable : null
    this.baseCurrencyId = params.base_currency_id ? params.base_currency_id : null
  }
}
